// Ops glyphs: icons only the operator's Ops pages use
// (docs/implement/lanes.md). Key = the icon's name, value = Lucide geometry,
// as in Icon.tsx.

export { opsGlyphs };

import {
    Activity,
    CircleDollarSign,
    Inbox,
    MessageSquare,
    PanelsTopLeft,
    Users,
} from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const opsGlyphs = {
    ops: Activity, // the Ops area: the app's pulse
    "ops-overview": PanelsTopLeft, // the Ops home: everything at a glance
    "ops-feedback": MessageSquare, // what testers sent
    "ops-accounts": Users, // everyone who can sign in
    "ops-cost": CircleDollarSign, // what the AI calls cost
    "ops-inbox": Inbox, // nothing sent yet
} satisfies AreaGlyphs;
